import { view } from '@yola/ws-sdk';
import { hasNonZeroBounds } from '../../common/helpers/get-element-with-visible-box';
import getTriggersPositionInfo from './get-triggers-position-info';

const getFloatingTriggersInfoForElement = ({
  elementId,
  scrollPosition,
  pageContainerSelector,
  viewportHeight,
  topbarHeight,
}) => {
  if (!elementId) return null;

  const element = view.accessors.getLiveElement(elementId);

  if (!element || !hasNonZeroBounds(element)) return null;

  const triggersPos = getTriggersPositionInfo(
    element,
    scrollPosition,
    pageContainerSelector,
    viewportHeight,
    topbarHeight
  );

  if (!triggersPos) return null;

  const { topTrigger, bottomTrigger } = triggersPos;

  return {
    topTrigger,
    bottomTrigger,
  };
};

export default getFloatingTriggersInfoForElement;
